import { useState } from "react";
import useApi from "../../../services/useApi";
import useAlerts from "../../../services/useAlerts";

const useCamaras = () => {
  const [stateModal, setStateModal] = useState({
    open: false,
    openEdit: false,
    id: "",
    nombre: "",
    nombreError: false,
  });

  const [stateModalEdit, setStateModalEdit] = useState({
    open: false,
    openEdit: false,
  });

  const { showAlertConfirm, showLoader, showToast } = useAlerts();

  const handleShowModal = (action) => {
    setStateModal({ ...stateModal, open: action, nombre: "" });
  };

  const handleShowModalEdit = (action) => {
    setStateModalEdit({ ...stateModalEdit, open: action });
  };

  const handleNombre = (e) => {
    setStateModal({ ...stateModal, nombre: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevenir el comportamiento predeterminado del formulario
    validateNombre(stateModal.nombre);
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter") {
      e.preventDefault();
      editChamber(id); // Llama a la función para enviar la petición
    }
  };

  const validateNombre = async () => {
    const { nombre } = stateModal;

    if (nombre.trim() !== "" && nombre.length >= 4 && nombre.length <= 100) {
      handleShowModal(false);
      await sendData(nombre);
      setStateModal({ stateModal, nombre: "" });
      await verSolicitudes();
    } else if (nombre.length < 4) {
      showAlertConfirm("info", "No puede contener menos de 4 caracteres");
    } else if (nombre.length > 100) {
      showAlertConfirm("info", "No puede contener más de 100 caracteres");
    } else {
      showAlertConfirm("info", "Nombre requerido");
    }
  };

  const deleteChamber = async (id) => {
    const confirmation = await showAlertConfirm(
      "question",
      "Confirmación",
      "¿Estás seguro de eliminar esta cámara?",
      true
    );
    if (confirmation) {
      showLoader();
      const { execute, data } = await services("DELETE", `v1/chambers/${id}`);
      if (execute) {
        await verSolicitudes();
        showAlertConfirm("success", data.mensaje);
      }
    }
  };

  const editChamber = async (id) => {
    const formData = new FormData();
    formData.append("nombre", stateModal.nombre);
    const { nombre } = stateModal;

    showLoader();
    if (nombre.trim() !== "" && nombre.length >= 4 && nombre.length <= 100) {
      const { execute, data } = await services(
        "PUT",
        `v1/chambers/${id}`,
        formData
      );
      if (execute) {
        await verSolicitudes();
        handleShowModalEdit(false);
        showAlertConfirm("success", data.mensaje);
        setStateModal({ stateModal, nombre: "" });
      }
    } else if (nombre.trim() === "" || nombre === "") {
      showAlertConfirm("info", "Nombre requerido");
    } else if (nombre.length < 4) {
      showAlertConfirm("info", "No puede contener menos de 4 caracteres");
    } else if (nombre.length > 100) {
      showAlertConfirm("info", "No puede contener más de 100 caracteres");
    } else {
      showAlertConfirm("info", "Nombre requerido");
    }
  };

  const setCurrentCamera = (id, nombre) => {
    handleShowModalEdit(true);
    setStateModal({ stateModal, nombre: nombre, id: id });
  };

  // Enviar datos POST
  const sendData = async (nombre) => {
    const formData = new FormData();

    formData.set("nombre", nombre);

    showLoader();
    const { execute, data } = await services("POST", "v1/chambers", formData);

    if (execute) {
      showAlertConfirm("success", data.mensaje);
    }
  };

  const { services } = useApi();

  const [stateCamaras, setStateCamaras] = useState({
    solicitudes: [],
  });

  const verSolicitudes = async () => {
    const { execute, data } = await services("GET", "v1/chambers");
    if (execute) {
      setStateCamaras({ ...stateCamaras, solicitudes: data.data });
      showToast("success", "Carga de información completa", "bottom-end", 2000);
    }
  };

  const loadCamaras = async () => {
    const { execute, data } = await services("GET", "v1/chambers");
    if (execute) {
      setStateCamaras({ ...stateCamaras, solicitudes: data.data });
      showToast("success", "Carga de información completa", "bottom-end", 2000);
    }
  };

  return {
    stateCamaras,
    stateModal,
    setStateModal,
    verSolicitudes,
    handleShowModal,
    handleNombre,
    handleSubmit,
    deleteChamber,
    editChamber,
    stateModalEdit,
    handleShowModalEdit,
    setCurrentCamera,
    handleKeyDown,
    loadCamaras,
  };
};
export default useCamaras;
